import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  Chip
} from '@mui/material';
import UserDashboard from './UserDashboard';
import AdminIcon from '@mui/icons-material/AdminPanelSettings';

const AdminUserView = ({ onSwitchView }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {/* Admin indicator banner */}
      <Paper 
        elevation={2} 
        sx={{ 
          p: 1.5, 
          mb: 3, 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          bgcolor: '#f8f9fa',
          borderLeft: '4px solid #3f51b5'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <AdminIcon sx={{ mr: 1, color: '#3f51b5' }} />
          <Typography variant="body1" fontWeight="medium">
            You are viewing the application as a regular user
          </Typography>
          <Chip 
            label="Admin Mode" 
            size="small" 
            color="primary" 
            variant="outlined" 
            sx={{ ml: 2 }}
          />
        </Box>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onSwitchView}
          size="small"
        >
          Return to Admin Dashboard
        </Button>
      </Paper>

      {/* Regular user dashboard */}
      <UserDashboard />
    </Box>
  );
};

export default AdminUserView; 